import {
  BasketballFoulAttribute,
  BasketballFourPointShotMadeAttribute,
  BasketballFourPointShotMissedAttribute,
  BasketballFreeThrowsAwardedAttribute,
  BasketballIncidentId,
  BasketballThreePointShotMadeAttribute,
  BasketballThreePointShotMissedAttribute,
  BasketballTurnoverAttribute,
  BasketballTwoPointShotMadeAttribute,
  BasketballTwoPointShotMissedAttribute,
} from '@collector/sportsapi-client-legacy'

import { HistoryIncidentsConfig } from '../../configuration'

export const historyIncidentsConfig: HistoryIncidentsConfig<BasketballIncidentId> =
  {
    [BasketballIncidentId.DefensiveRebound]: {
      participant: 'player',
    },
    [BasketballIncidentId.OffensiveRebound]: {
      participant: 'player',
    },
    [BasketballIncidentId.Block]: {
      participant: 'player',
      assistant: {
        name: 'blocked on',
        shouldLoadOppositeSubParticipants: true,
      },
    },
    [BasketballIncidentId.FreeThrowsAwarded]: {
      participant: 'player',
      attributeIds: [
        BasketballFreeThrowsAwardedAttribute.One,
        BasketballFreeThrowsAwardedAttribute.Two,
        BasketballFreeThrowsAwardedAttribute.Three,
      ],
    },
    [BasketballIncidentId.FreeThrowMissed]: {
      participant: 'player',
    },
    [BasketballIncidentId.TwoPointShotMissed]: {
      participant: 'player',
      attributeIds: [
        BasketballTwoPointShotMissedAttribute.JumpShot,
        BasketballTwoPointShotMissedAttribute.Layup,
        BasketballTwoPointShotMissedAttribute.Dunk,
        BasketballTwoPointShotMissedAttribute.Hook,
      ],
    },
    [BasketballIncidentId.ThreePointShotMissed]: {
      participant: 'player',
      attributeIds: [BasketballThreePointShotMissedAttribute.JumpShot],
    },
    [BasketballIncidentId.FourPointShotMissed]: {
      participant: 'player',
      attributeIds: [BasketballFourPointShotMissedAttribute.JumpShot],
    },
    [BasketballIncidentId.Steal]: {
      participant: 'player',
      assistant: {
        name: 'steal from',
        shouldLoadOppositeSubParticipants: true,
      },
    },
    [BasketballIncidentId.Turnover]: {
      participant: 'player',
      attributeIds: [
        BasketballTurnoverAttribute.OutOfBounds,
        BasketballTurnoverAttribute.Travelling,
        BasketballTurnoverAttribute.ShotClock,
        BasketballTurnoverAttribute.Backcourt,
        BasketballTurnoverAttribute.EightSeconds,
        BasketballTurnoverAttribute.FiveSeconds,
        BasketballTurnoverAttribute.ThreeSeconds,
        BasketballTurnoverAttribute.DoubleDribble,
        BasketballTurnoverAttribute.OffensiveGoaltending,
      ],
    },
    [BasketballIncidentId.TwoPointShotMade]: {
      participant: {
        name: 'player',
        required: true,
      },
      assistant: 'assistant',
      attributeIds: [
        BasketballTwoPointShotMadeAttribute.JumpShot,
        BasketballTwoPointShotMadeAttribute.Layup,
        BasketballTwoPointShotMadeAttribute.Dunk,
        BasketballTwoPointShotMadeAttribute.Hook,
        BasketballTwoPointShotMadeAttribute.PointsFromTurnovers,
        BasketballTwoPointShotMadeAttribute.PointsInThePaint,
        BasketballTwoPointShotMadeAttribute.SecondChancePoints,
        BasketballTwoPointShotMadeAttribute.FastBreakPoints,
      ],
    },
    [BasketballIncidentId.ThreePointShotMade]: {
      participant: {
        name: 'player',
        required: true,
      },
      assistant: 'assistant',
      attributeIds: [
        BasketballThreePointShotMadeAttribute.JumpShot,
        BasketballThreePointShotMadeAttribute.PointsFromTurnovers,
        BasketballThreePointShotMadeAttribute.SecondChancePoints,
        BasketballThreePointShotMadeAttribute.FastBreakPoints,
      ],
    },
    [BasketballIncidentId.FourPointShotMade]: {
      participant: {
        name: 'player',
        required: true,
      },
      assistant: 'assistant',
      attributeIds: [BasketballFourPointShotMadeAttribute.JumpShot],
    },
    [BasketballIncidentId.Foul]: {
      participant: 'player',
      assistant: {
        name: 'foul on',
        shouldLoadOppositeSubParticipants: true,
      },
      attributeIds: [
        BasketballFoulAttribute.Offensive,
        BasketballFoulAttribute.Technical,
        BasketballFoulAttribute.Unsportsmanlike,
      ],
    },
    [BasketballIncidentId.FreeThrowIn]: {
      participant: {
        name: 'player',
        required: true,
      },
      assistant: 'assistant',
    },
  }
